<div class="dlg-container" #dlgContents (click)="$event.stopPropagation()">
    <!--  *** CATEGORY ADD *** -->
    <div *ngIf="data.type == CATEGORY_ADD" class="dlg-contents">
        <div class="dlg-title" data-cy="channels-create-category-modal-header">
            {{ 'channel.add-category' | translate }}
        </div>
        <div class="dlg-inputs">
            <div class="dlg-input">
                <app-channel-text-input
                    name="category"
                    label="channel.create.group.form.name"
                    [value]="editDisplayName"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.category"></app-channel-text-input>
            </div>
            <div class="dlg-input">
                <app-channel-text-input
                    name="rowId"
                    label="channel.create.category.form.number"
                    [value]="editCategoryNumber"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.rowId"
                    [maxLength]="2"></app-channel-text-input>
            </div>
        </div>
        <div class="dlg-buttons">
            <button (click)="close()" class="primary" data-cy="channels-create-category-cancel-button">
                {{ 'dlg.cancel' | translate }}
            </button>
            <button
                (click)="confirmButtonClick()"
                class="white"
                data-cy="channels-create-category-submit-button"
                [class.disabledButton]="saveIsDisabled()">
                {{ 'dlg.create' | translate }}
            </button>
        </div>
    </div>

    <!--  *** CATEGORY EDIT *** -->
    <div *ngIf="data.type == CATEGORY_EDIT" class="dlg-contents">
        <div class="dlg-title" data-cy="channels-edit-category-modal-header">
            {{ data.title | translate }}
        </div>
        <div class="dlg-inputs">
            <div class="dlg-input">
                <app-channel-text-input
                    name="category"
                    label="channel.create.group.form.name"
                    [value]="data.selectedChannelCategory.category"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.category"></app-channel-text-input>
            </div>
            <div class="dlg-input">
                <app-channel-text-input
                    name="rowId"
                    label="channel.create.category.form.number"
                    [value]="editCategoryNumber"
                    [isDisabled]="isSystemGroup()"
                    (onInputChange)="onInputChange($event)"
                    (onFocusChange)="onInputChange($event)"
                    [inputError]="validationErrors?.rowId"></app-channel-text-input>
            </div>
        </div>
        <div class="dlg-buttons">
            <button (click)="close()" class="primary" data-cy="channels-edit-category-cancel-button">
                {{ 'dlg.cancel' | translate }}
            </button>
            <button
                (click)="confirmButtonClick()"
                class="white"
                data-cy="channels-edit-category-submit-button"
                [class.disabledButton]="saveIsDisabled()">
                {{ 'dlg.save' | translate }}
            </button>
        </div>
    </div>

    <!--  *** CATEGORY DELETE *** -->
    <div *ngIf="data.type == CATEGORY_DELETE" class="dlg-contents">
        <div class="dlg-title" data-cy="channels-delete-category-modal-header">
            {{ data.title | translate }}
        </div>
        <div class="dlg-description" data-cy="channels-delete-category-modal-body">
            {{ data.description | translate }}
        </div>
        <div class="dlg-buttons">
            <button (click)="close()" class="primary" data-cy="channels-delete-category-cancel-button">
                {{ 'dlg.cancel' | translate }}
            </button>
            <button (click)="confirmButtonClick()" class="white" data-cy="channels-delete-category-submit-button">
                {{ 'dlg.confirm' | translate }}
            </button>
        </div>
    </div>
</div>
